function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { useId as n } from "react";
import { DefaultMap as f } from '../utils/default-map.js';
import { createStore as u } from '../utils/store.js';
import { useIsoMorphicEffect as c } from './use-iso-morphic-effect.js';
import { useStore as l } from './use-store.js';
var p = new f(function () {
  return u(function () {
    return [];
  }, {
    ADD: function ADD(r) {
      return this.includes(r) ? this : [].concat(_toConsumableArray(this), [r]);
    },
    REMOVE: function REMOVE(r) {
      var e = this.indexOf(r);
      if (e === -1) return this;
      var t = this.slice();
      return t.splice(e, 1), t;
    }
  });
});
function x(r, e) {
  var t = p.get(e),
    i = n(),
    h = l(t);
  if (c(function () {
    if (r) return t.dispatch("ADD", i), function () {
      return t.dispatch("REMOVE", i);
    };
  }, [t, r]), !r) return !1;
  var s = h.indexOf(i),
    o = h.length;
  return s === -1 && (s = o, o += 1), s === o - 1;
}
export { x as useIsTopLayer };